/**
 * Icon: abstact component to render SVG icons.
 * @module components/icon
 */

import React from "react";
import InlineSVG from "react-inlinesvg";

import { cn } from "@/utils/cn";

export interface IconProps extends React.HTMLAttributes<HTMLDivElement> {
  src: string;
  id?: string;
  alt?: string;
  className?: string;
}

/**
 * @deprecated Use the UI Icon component directly.
 */
const Icon: React.FC<IconProps> = ({ src, alt, className, ...rest }) => {
  return (
    <div
      className={cn(
        "flex size-4 items-center justify-center transition duration-200",
        className,
      )}
      {...rest}
    >
      <InlineSVG
        src={src}
        title={alt}
        className="size-full transition duration-200"
        loader={<></>}
      />
    </div>
  );
};

export default Icon;
